import { API_BASE_URL, FAILURE, POST, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function createConfiguracionEmpresaCliente(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/configuracion-empresa-cliente/create-configuracion-empresa-cliente",
            API_BASE_URL + "/configuracion-empresa-cliente/create-configuracion-empresa-cliente",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("createConfiguracionEmpresaCliente err");
        console.log(err);
        return { error: true };
    }
}

export async function obtenerConfiguracionEmpresaCliente(obj) {
    try {
        let data = { error: true };
        const { code, message, body } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/configuracion-empresa-cliente/obtener-configuracion-empresa-cliente",
            API_BASE_URL + "/configuracion-empresa-cliente/obtener-configuracion-empresa-cliente",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
            if (Array.isArray(body) === true && body.length > 0) {
                data.body = body[0];
            } else {
                data.body = null;
            }
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("obtenerConfiguracionEmpresaCliente err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function actualizarConfiguracionEmpresaCliente(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/configuracion-empresa-cliente/actualizar-configuracion-empresa-cliente",
            API_BASE_URL + "/configuracion-empresa-cliente/actualizar-configuracion-empresa-cliente",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("actualizarConfiguracionEmpresaCliente err");
        console.log(err);
        return { error: true, message: err };
    }
}
